import { createAction } from 'app-components/flux/core/actionHelpers';

export const getShares = createAction(
  'GET_SHARES',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getSharesSuccess = createAction('GET_SHARES_SUCCESS');
export const getSharesFailure = createAction('GET_SHARES_FAILURE');

export const createShare = createAction(
  'CREATE_SHARE',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const createShareSuccess = createAction(
  'CREATE_SHARE_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const createShareFailure = createAction('CREATE_SHARE_FAILURE');

export const updateShare = createAction(
  'UPDATE_SHARE',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const updateShareSuccess = createAction('UPDATE_SHARE_SUCCESS');
export const updateShareFailure = createAction('UPDATE_SHARE_FAILURE');

export const deleteShare = createAction(
  'DELETE_SHARE',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const deleteShareSuccess = createAction('DELETE_SHARE_SUCCESS');
export const deleteShareFailure = createAction('DELETE_SHARE_FAILURE');
